import { render, staticRenderFns } from "./viewTreatmentReport.vue?vue&type=template&id=389e134e&scoped=true"
import script from "./viewTreatmentReport.vue?vue&type=script&lang=js"
export * from "./viewTreatmentReport.vue?vue&type=script&lang=js"
import style0 from "./viewTreatmentReport.vue?vue&type=style&index=0&id=389e134e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e134e",
  null
  
)

export default component.exports